import { useEffect, useState } from "react";
import { useAuth } from "../../context/Auth";
import { AddIcon2, SaveIcon } from "../../icons/Icon";
import Button from "../Dealers/Button";
import TopTabBar from "../Tanolet/TopTabBar";
import styles from "./Printers.module.css";
import IPSetter from "./IPSetter";
import { useToast } from "../Toaster/Toaster";

const Printers = () => {
  const { show } = useToast();
  const initialIPs = {
    packingSlip: "",
    invoice: "",
    label: "",
    receipt: "",
    report: "",
  };

  const { mode } = useAuth();
  const [IPs, setIPs] = useState(initialIPs);

  useEffect(() => {
    const storedIPs = localStorage.getItem("printerIPs");
    if (storedIPs) {
      setIPs(JSON.parse(storedIPs));
    }
  }, []);

  const isValidIP = (ip) => {
    const ipRegex =
      /^(25[0-5]|2[0-4]\d|1\d{2}|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d{2}|[1-9]?\d)){3}$/;
    return ipRegex.test(ip);
  };

  const saveToLocalStorage = () => {
    const invalidFields = Object.entries(IPs).filter(
      ([_, ip]) => ip && !isValidIP(ip),
    );

    if (invalidFields.length > 0) {
      const fieldNames = invalidFields.map(([key]) => key).join(", ");
      show(`Invalid IP address in ${fieldNames}`, "error");
      return;
    }

    localStorage.setItem("printerIPs", JSON.stringify(IPs));
    show("IP Updated", "success");
  };

  const shouldShowFooter =
    Object.values(IPs).some((val) => val !== "") ||
    JSON.stringify(IPs) !== JSON.stringify(initialIPs);

  return (
    <div
      style={mode ? { backgroundColor: "#2C2E33", borderColor: "#2C2E33" } : {}}
      className={styles.printers}
    >
      <div className={styles.printers_top}>
        <TopTabBar text={"Printers"} />
        <div>
          <Button
            buttonText={"Add New"}
            buttonBgColor={"#4164E3"}
            buttonTextColor={"#FFFFFF"}
            buttonIcon={<AddIcon2 />}
          />
        </div>
      </div>

      <div className={styles.printer_con}>
        <IPSetter
          mode={mode}
          header={"Packing Slip"}
          value={IPs}
          setValue={setIPs}
          fieldKey="packingSlip"
        />
        <IPSetter
          mode={mode}
          header={"Invoice"}
          value={IPs}
          setValue={setIPs}
          fieldKey="invoice"
        />
        <IPSetter
          mode={mode}
          header={"Label"}
          value={IPs}
          setValue={setIPs}
          fieldKey="label"
        />
        <IPSetter
          mode={mode}
          header={"Receipt"}
          value={IPs}
          setValue={setIPs}
          fieldKey="receipt"
        />
        <IPSetter
          mode={mode}
          header={"Report"}
          value={IPs}
          setValue={setIPs}
          fieldKey="report"
        />
        <IPSetter
          mode={mode}
          header={"Salary Slip"}
          value={IPs}
          setValue={setIPs}
          fieldKey="salary"
        />
      </div>

      {shouldShowFooter && (
        <div className={`${styles.footer} ${mode ? styles.footer_dark : ""}`}>
          <div className={styles.save_btn_wrapper}>
            <Button
              buttonIcon={<SaveIcon />}
              buttonText={"SAVE"}
              buttonBgColor={"#4164E3"}
              buttonTextColor={"#ffffff"}
              buttonClick={saveToLocalStorage}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default Printers;
